class ViewBoxSvg {

    /**
     * @since 5.0.60
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '.site-logo img';

        // Run initialization
        this.init();

        // Run again when the page resizes
        $(window).on('resize', () => this.init());
    }

    /**
     * Initialize the class.
     *
     * @since 5.0.60
     * @method init
     * @returns object The initialized map
     */
    init() {
        // If there are no countdowns, bail
        if (!$(this.selector).length) return;

        // Declare and initialize
        var bounder   = this.setBounds;
        var onVisible = this.onVisible;

        // Add classes to each of them
        $(this.selector).each(function () {

            // Declare and initialize
            var img = $(this)[0];
            var src = img.src;

            // We only do this for SVGs
            /*if (!src.match(/\.svg\??/))
                return;*/

            // Fire up a new image object
            var svg = new Image();

            // Either watch for visibility changes or set bounds right away
            if (!$(this).is(':visible'))
                onVisible(img, () => bounder(img, svg));
            else
                svg.onload = () => bounder(img, svg);

            // Set the image source
            svg.src = img.src;

        });

        // Prevent leaks
        return;
    }

    /**
     * Watches or when the element becomes visible.
     *
     * @since 5.0.60
     * @method onVisible
     * @param object element is the element to observer
     * @param function callback is the callback to run
     * @return void
     */
    onVisible(element, callback) {
        // Declare and initialize
        var options = {
            root: document.documentElement,
        };

        // Set up a new observer
        var observer = new IntersectionObserver((entries, observer) => {
            // Run for each matching element
            entries.forEach(entry => {

                // Run the callback when the change happens
                callback(entry.intersectionRatio > 0);

            });
        }, options);

        // Start watching
        observer.observe(element);
    }

    /**
     * Run the boundary setter.
     *
     * @since 5.0.60
     * @method setBounds
     * @param object img is the image for which to set boundaries
     * @param object ctx is the active context
     * return void
     */
    setBounds(img, ctx) {

        // Undo any width settings
        $(img).width('');

        // Declare and initialize
        let natural  = {
            w: ctx.naturalWidth,
            h: ctx.naturalHeight
        };
        let rendered = {
            w: $(img).parent().width(),
            h: $(img).parent().height()
        };

        // Do nothing if there is no rendered width
        if (0 === rendered.w)
            return;

        // Calculate the differential
        let diff = rendered.h / natural.h;

        // Apply it to the image
        $(img).width(natural.w * diff);

        // Make it visible again
        $(img).css({opacity: 1});

    }

}

export default ViewBoxSvg;